// material-ui

// assets

// ================================|| UI LIST - SIMPLE LIST ||================================ //

export default function SimpleList() {
  // Generate Grid

  function main(): any {
    return <></>
  }

  let output_main = main()

  return output_main
}
